<template>
  <transition name="el-fade-in-linear">
    <div
      v-if="show"
      class="zhezhaoceng6 flex ai_c jc_c fd_c can"
      @click="close"
    >
      <div class="popup_body" @click.stop="">
        <template v-if="list.length">
          <div class="img_cell">
            <img class="bg_img" :src="list[currentImageIndex].content" alt="" />
            <el-image
              class="can"
              style="width: 803px; height: 500px; border-radius: 8px"
              :src="list[currentImageIndex].content"
              :preview-src-list="list.map((item) => item.content)"
              fit="contain"
              :initial-index="currentImageIndex"
            />
            <div class="create_time1">
              {{ list[currentImageIndex].createtime_text }}
            </div>
            <img
              class="icon_arrow_left"
              src="@/assets/img/circleV2/icon_arrow_left.png"
              alt=""
              @click="handlePrev"
            />
            <img
              class="icon_arrow_right"
              src="@/assets/img/circleV2/icon_arrow_right.png"
              alt=""
              @click="handleNext"
            />
          </div>
          <LateralScrolling ref="lateralScrolling">
            <div class="img_small_cells">
              <div
                v-for="(item, index) in list"
                :key="index"
                class="img_small_cell"
                :class="{ img_small_cell_active: currentImageIndex == index }"
              >
                <!-- <el-image
                class="can"
                style="width: 180px; height: 120px;border-radius: 8px;"
                :src="item.content"
                :preview-src-list="list.map(item=>item.content)"
                fit="cover"
                :initial-index="index"
              /> -->
                <img
                  class="can"
                  :src="item.content"
                  alt=""
                  @click="currentImageIndex = index"
                />
                <div class="create_time2">
                  {{ item.createtime_text }}
                </div>
              </div>
            </div>
          </LateralScrolling>
        </template>
        <Nodata v-else />
      </div>
    </div>
  </transition>
</template>

<script>
import request from "@/utils/request";
import popupMixin from "@/utils/popupMixin";
export default {
  mixins: [popupMixin],
  data() {
    return {
      show: false,
      list: [],
      currentImageIndex: 0,
    };
  },
  methods: {
    async open() {
      const res = await request.post("/teacher/circle/getCircleStrategy", {
        circle_id: 66,
      });
      this.list = res.data;
      this.show = true;
    },
    close() {
      this.show = false;
    },
    handlePrev() {
      const currentImageIndex = this.currentImageIndex;
      if (currentImageIndex > 0) {
        this.currentImageIndex--;
      } else {
        this.currentImageIndex = this.list.length - 1;
      }
      this.setLateralScrolling(this.currentImageIndex);
    },
    handleNext() {
      const currentImageIndex = this.currentImageIndex;
      if (currentImageIndex < this.list.length - 1) {
        this.currentImageIndex++;
      } else {
        this.currentImageIndex = 0;
      }
      this.setLateralScrolling(this.currentImageIndex);
    },
    setLateralScrolling(index) {
      // 获取元素参数【宽度、高度、距离视窗左边、距离视窗顶部】
      const xilieCell0 = document
        .getElementsByClassName("img_small_cell")[0]
        .getBoundingClientRect();
      const xilieCell = document
        .getElementsByClassName("img_small_cell")
        [index].getBoundingClientRect();

      this.$refs.lateralScrolling.handleMove(xilieCell.left - xilieCell0.left);
    },
  },
};
</script>

<style scoped>
.zhezhaoceng6 {
  z-index: 1999;
}

.popup_body {
  position: relative;
  width: 835px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  box-sizing: border-box;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.img_cell {
  position: relative;
  width: 803px;
  height: 500px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 10px;
}

.bg_img {
  position: absolute;
  left: 0;
  top: 0;
  filter: blur(50px);
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.img_small_cells {
  display: flex;
  column-gap: 12px;
}

.img_small_cell {
  position: relative;
  width: 150px;
  height: 100px;
  overflow: hidden;
  border-radius: 8px;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.img_small_cell_active {
  border: 3px solid #4571e7;
}

.img_small_cell img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.create_time1 {
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 0 16px;
  width: 100%;
  height: 36px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0px 0px 6px 6px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}

.icon_arrow_left,
.icon_arrow_right {
  position: absolute;
  top: 232px;
  width: 36px;
  height: 36px;
  display: block;
  cursor: pointer;
}

.icon_arrow_left {
  left: 40px;
}

.icon_arrow_right {
  right: 40px;
}

.create_time2 {
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 0 10px;
  width: 100%;
  height: 26px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0px 0px 6px 6px;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
}
</style>
